import {
  AuthConfig,
  endOfDay,
  getControlCategoryName,
  getControlName,
  getLocalUTCOffset,
  ObjectException,
  PolicyException,
  queries,
} from "@theprelude/core";
import { addHours, subHours } from "date-fns";
import { createQuery } from "@/lib/create-query";

export type Exception =
  | (ObjectException & { type: "object"; alpha: string })
  | (PolicyException & { type: "policy"; alpha: string });

export function calculateExpirationDate(expires: string) {
  const baselineDay = endOfDay(new Date(expires));
  const tzOffset = getLocalUTCOffset();

  return Math.sign(tzOffset) === -1
    ? subHours(baselineDay, tzOffset)
    : addHours(baselineDay, tzOffset);
}

const getExceptionsData = (
  objectExceptions: ObjectException[],
  policyExceptions: PolicyException[],
): Exception[] =>
  [
    ...objectExceptions.map(
      (e): Exception => ({
        ...e,
        type: "object",
        alpha: [getControlCategoryName(e.category), e.name].join(" › "),
      }),
    ),
    ...policyExceptions.map(
      (e): Exception => ({
        ...e,
        type: "policy",
        alpha: [
          getControlCategoryName(e.category),
          getControlName(e.control),
          e.policy_name,
        ].join(" › "),
      }),
    ),
  ].sort((a, b) => a.alpha.localeCompare(b.alpha));

export const exceptionsQuery = (authConfig: AuthConfig) =>
  createQuery({
    queries: [
      queries.scm.objectExceptions(authConfig),
      queries.scm.policyExceptions(authConfig),
    ],
    queryFn: getExceptionsData,
  });
